import React, { Component, useEffect } from 'react';
import {
  BrowserRouter as Router,
  Route,
  Link,
  Redirect,
  Switch
} from 'react-router-dom'

import Auth from './store/AuthStore.js'
import { Lazy } from './helpers';
import Api from './services/Api.js';
import ScrollMemory from 'react-router-scroll-memory';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';
import themeObject from './theme.js'
import { addCss, addJS, ifLanguageDoesNotSupportUseEnExceptUK } from './helpers.js';
import i18n from './i18n'

const theme = createMuiTheme(themeObject);

const Dashboard = (props) => <Lazy {...props} load={() => import('./pages/Buyer.Dashboard')}/>
const Merchants = (props) => <Lazy {...props} load={() => import('./pages/Buyer.Merchants')}/>
const Login = (props) => <Lazy {...props} load={() => import('./pages/Login')}/>
const Popup = (props) => <Lazy {...props} load={() => import('./pages/Popup')}/>
const Page = (props) => <Lazy {...props} load={() => import('./pages/Page')}/>
const Registration = (props) => <Lazy {...props} load={() => import('./pages/Registration')}/>
const ForgotPassword = (props) => <Lazy {...props} load={() => import('./pages/ForgotPassword')}/>
const Reset = (props) => <Lazy {...props} load={() => import('./pages/Reset')}/>
const Activate = (props) => <Lazy {...props} load={() => import('./pages/Activate')}/>
const Item = (props) => <Lazy {...props} load={() => import('./pages/Item')}/>
const Checkout = (props) => <Lazy {...props} load={() => import('./pages/Checkout')}/>
const AdminDashboard = (props) => <Lazy {...props} load={() => import('./pages/Admin.Dashboard')}/>
const SellerDashboard = (props) => <Lazy {...props} load={() => import('./pages/Seller.Dashboard')}/>
const AffiliateDashboard = (props) => <Lazy {...props} load={() => import('./pages/Affiliate.Dashboard')}/>
const AffiliateMerchants = (props) => <Lazy {...props} load={() => import('./pages/Affiliate.Merchants')}/>
const RegistrationAffiliates = (props) => <Lazy {...props} load={() => import('./pages/Registration.Affiliates')}/>
const RegistrationMerchants = (props) => <Lazy {...props} load={() => import('./pages/Registration.Merchants')}/>
const RegistrationUsers = (props) => <Lazy {...props} load={() => import('./pages/Registration.Users')}/>


let prod = process.env.NODE_ENV != 'development';

export const paths = new Proxy({

  // login/registration/reset...
  login: '/login',
  registration: '/',
  forgotPassword: '/forgotPassword',
  activate: '/activate',
  reset: '/reset',
  registerAffiliates: '/registerAffiliates',
  registerMerchants: '/registerMerchants',
  registerUsers: '/registerUsers',
  

  /// Buyer
  // Buyer dashboard
  dashboard: '/dashboard',
  account: '/dashboard/account',

  //Buyer merchants
  merchants:  '/merchants',
  seller:  '/merchants/:seller',
  orders:  '/merchants/:seller/orders',
  categories:  '/merchants/:seller/categories',
  payments:  '/merchants/:seller/payments',
  refunds:  '/merchants/:seller/refunds',
  contacts:  '/merchants/:seller/contacts',
  about:  '/merchants/:seller/about',



  // widgwet
  banner:  '/banner',
  popup:  '/popup',
  page:  '/page',
  checkout:  '/checkout',


  // Admin

  adminDashboard: '/admin',
  adminPayouts: '/admin/payouts',
  adminPayoutsSeller: '/admin/payouts/seller',
  adminOrdersFilter: '/admin/filter',
  adminOrders: '/admin/orders',
  adminOrder: '/admin/order',
  adminOrderDetails: '/admin/order/:seller/:id',
  adminAffiliates: '/admin/affiliate',
  adminAffiliate: '/admin/affiliate/:id/:bundlecode',
  adminAffiliateInfo: '/admin/affiliate/info/:id',
  adminMerchants: '/admin/merch',
  adminMerchantInfo: '/admin/merch/info/:id',
  adminWidget: '/admin/widgets',
  adminWidgetProducts: '/admin/widget/:id',
  adminSmartLinks: '/admin/smartlinks',
  adminSmartLinkProducts: '/admin/smartlink/:id',
  adminSettings: '/admin/settings',
  adminSettingsQueue: '/admin/settings/queue',
  adminSettingsElastic: '/admin/settings/elastic',

  /// Affiliate
  //Affiliate dashboard
  affiliateDashboard: '/affiliate',
  affiliateAccount: '/affiliate/account',
  affiliateCatalog: '/affiliate/catalog',
  affiliateAccountPayouts: '/affiliate/account/payouts',
  affiliateAccountCardDetails: '/affiliate/account/carddetails',
  affiliateAccountReferrals: '/affiliate/account/referrals',
  // Affiliate merchants
  affiliateSellers: '/affiliate/merchants',
  affiliateProducts: '/affiliate/products',
  affiliateSeller: '/affiliate/merchants/:seller',
  affiliateAmazone: '/affiliate/merchants/affiliateAmazone',
  affiliateSellerProducts: '/affiliate/merchants/:seller/products',
  affiliateSellerPayments: '/affiliate/merchants/:seller/payments',
  affiliateSellerRefunds: '/affiliate/merchants/:seller/refunds',
  affiliateSellerContacts:  '/affiliate/merchants/:seller/contacts',
  affiliateSellerAbout:  '/affiliate/merchants/:seller/about',
  affiliateSellerTraffics:  '/affiliate/merchants/:seller/traffics',
  affiliateSellerActions:  '/affiliate/merchants/:seller/actions',
  affiliateSellerRules:  '/affiliate/merchants/:seller/rules',
  affiliateSellerAreas:  '/affiliate/merchants/:seller/areas',
  affiliateSellerProduct:  '/affiliate/merchants/:seller/code/:id',
  affiliateSellerProductDetails:  '/affiliate/merchants/:seller/details/:id',
  affiliateSellerWidget:  '/affiliate/merchants/:seller/code/:id/widget',
  affiliateSellerButton:  '/affiliate/merchants/:seller/code/:id/button',
  affiliateSellerReferral:  '/affiliate/merchants/:seller/code/:id/referral',
  affiliateSellerBanner:  '/affiliate/merchants/:seller/code/:id/banner',
  affiliateOrders:  '/affiliate/orders',
  affiliateOrdersFilter: '/affiliate/filter',
  affiliateBundle:  '/affiliate/bundle',
  affiliateBundleProducts:  '/affiliate/bundleProducts/:id',
  affiliateSmartLinks:  '/affiliate/smartlinks',
  affiliateSmartLinkProducts:  '/affiliate/smartlink/:id',

  
  /// Seller
  //Seller dashboard
  sellerDashboard: '/seller',
  sellerOrder: '/seller/order',
  sellerOrders: '/seller/orders',
  sellerOrdersFilter: '/seller/filter',
  sellerOrderDetails: '/seller/order/:id',
  sellerProducts: '/seller/products',
  sellerProductsFeed: '/seller/products/feed',
  sellerProductsLink: '/seller/products/link/:id?',
  sellerLinksMeta: '/seller/products/links',
  sellerProductDetails: '/seller/products/:id',
  sellerAccount: '/seller/account',
  sellerAccountPaymentMethods: '/seller/account/paymentmethods',
  sellerAccountCheckout: '/seller/account/checkout',
  sellerAccountAbout: '/seller/account/about',
  sellerAccountPayments: '/seller/account/payments',
  sellerAccountRefunds: '/seller/account/refunds',
  sellerAccountContacts: '/seller/account/contacts',
  sellerAccountPayouts: '/seller/account/payouts',
  sellerAccountAreas: '/seller/account/areas',
  sellerAccountCPA: '/seller/account/cpa',


}, {
  get: (target, prop, receiver) => {
    if(prod){
      return '/system' + Reflect.get(target, prop, receiver)
    }
    return Reflect.get(target, prop, receiver)
  }
})

export class Wrapper extends Component {
 
  render() {

    return(
      <Router>
      <MuiThemeProvider theme={theme}>
        {this.props.children}
      </MuiThemeProvider>
    </Router>
    );
  }
}


class App extends Component {
  async componentWillMount() {
    
    Auth.init();
    
    // if(Auth.isAuthenticated) try not refrash
    //   Api.refreshToken();

    if (typeof window === 'undefined') return
    window.addEventListener('beforeunload', this.handleBeforeUnload)
    document.addEventListener('touchstart', { });
  }
 
  componentWillUnmount() {
    if (typeof window === 'undefined') return
    window.removeEventListener('beforeunload', this.handleBeforeUnload)
  }

  handleBeforeUnload() {

  }

  render() {

    return(
      <Router>
      <MuiThemeProvider theme={theme}>
        {/* <ScrollMemory elementID={'table'}/> */}
        <Switch>
          <StartRouter path={paths.registration} exact component={Registration}/>
          <Route path={paths.login} exact component={Login}/>
          <Route path={paths.activate} exact component={Activate}/>
          <Route path={paths.forgotPassword} exact component={ForgotPassword}/>
          <Route path={paths.reset} component={Reset}/>
          <Route path={paths.registerAffiliates} component={RegistrationAffiliates}/>
          <Route path={paths.registerMerchants} component={RegistrationMerchants}/>
          <Route path={paths.registerUsers} component={RegistrationUsers}/>


          <PrivateRoute path={paths.merchants} role={['user']} component={Merchants}/>
          <PrivateRoute path={paths.dashboard} role={['user']} component={Dashboard}/>

          <Route path={paths.checkout} component={Checkout}/>


          <PrivateRoute path={paths.adminDashboard} role={['admin']} component={AdminDashboard}/>

          <PrivateRoute path={paths.sellerDashboard} role={['seller']} component={SellerDashboard}/>

          <PrivateRoute path={paths.affiliateDashboard} role={['affiliate']} component={AffiliateDashboard}/>

          <Route path={paths.banner} component={Item}/>
          <Route path={paths.popup} component={Popup}/>
          <Route path={paths.page} component={Page}/>
          <Route path='*' exact component={(args) => {
            let {location} = args;
            console.log(args)
            return (
              <div className="f f-align-2-2 f-col">
                <p>404</p>
                <p>Page on {location.pathname} is not found.</p>
              </div>
            )}}
          />
        </Switch>
      </MuiThemeProvider>
    </Router>
    );
  }
}


const StartRouter = ({ component: Component, ...rest }) => (
  <Route exact {...rest} render={props => {
    if(!Auth.isAuthenticated) return  <Route path={paths.registration} exact component={Registration}/>

    switch (Auth.role) {
    case 'admin':
        return   <Redirect to={paths.adminDashboard} />
        break;
    case 'seller':
        return   <Redirect to={paths.sellerDashboard} />
         break;
    case 'affiliate':
         return   <Redirect to={paths.affiliateDashboard} />
          break;
    case 'user':
        return   <Redirect to={paths.dashboard} />
        break;
    default:
        return  <Redirect to={'/'} />
        break;
    }
    }
  } />
)


const PrivateRoute =  ({ component: Component, ...rest }) => {
  
    let isAllowed =  Auth.isAuthenticated && rest.role.includes(Auth.role);

    useEffect(() => {
      if(isAllowed){  

        addCss('https://fonts.googleapis.com/icon?family=Material+Icons', 'Material+Icons');
        i18n.changeLanguage(ifLanguageDoesNotSupportUseEnExceptUK(Auth.primary_user_language));

        if(['user', 'affiliate', 'seller'].indexOf( rest.role[0] ) != -1  && prod )
          addJS('https://code-ya.jivosite.com/widget/cQltV05NMt', null, 'jivosite', () => {
            window.jivo_onLoadCallback = () => {
              window.jivo_api.setContactInfo({
                "name": `${Auth.first_name?Auth.first_name:''} ${Auth.last_name?Auth.last_name:''}`,
                "email": Auth.email,
             }); 
            }
          });
      
      }
    });
    return (
        <Route {...rest} render={props => (
          isAllowed ? (
             <Component currentRole={Auth.role} {...rest}/>
          ) : (
              <Redirect to={{
                pathname: paths.registration,
                state: { from: props.location }
              }} />
            )
        )} />)
  }


export default App;
